module.exports = __webpack_public_path__ + "img/default-avator.6b586071.png";